import { render } from "./IconComponent.vue?vue&type=template&id=1c389714&scoped=true"
import script from "./IconComponent.vue?vue&type=script&lang=js"
export * from "./IconComponent.vue?vue&type=script&lang=js"

import "./IconComponent.vue?vue&type=style&index=0&id=1c389714&scoped=true&lang=css"
script.render = render
script.__scopeId = "data-v-1c389714"

export default script